import { autoRegisterFeature } from '@store/features/factory';

import { toolbar } from './store/feature';

// Auto-register the feature
autoRegisterFeature(toolbar);

// Export everything
export * from './components';
export * from './constants';
export * from './store';
export * from './types';
